<template>
  <base-section
    id="companions"
  >
    <!---
    <base-section-heading title="Program Committee">
    </base-section-heading>
    --->
    <v-container>
      <base-title
        title="Program Committee Companions"
        size="text-h4"
        class="text-center"
      />
      <base-section-heading
      divider=null
      >
      The Companions of the Program Committee are well-recognized professionals in the scientific testing community. They had been being also in European Test Symposium organization for many editions and thus they are aware of the technical level expectations of the ETS conference.
      </base-section-heading>
      <v-row>
        <v-col
          v-for="(companion, i) in companions"
          :key="i"
          cols="12"
          md="6"
        >
          <base-section
            space="0"
            style="text-align: left"
          >
            {{ companion.title }} - <i>{{ companion.text }}</i>
          </base-section>
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Companions',
    data: () => ({
      isMobile: false,
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      companions: [
        {
          title: 'Juergen Alt',
          text: 'Infineon Technologies AG',
        },
        {
          title: 'Bernd Becker',
          text: 'University of Freiburg, DE',
        },
        {
          title: 'Luigi Carro',
          text: 'UFRGS, BR',
        },
        {
          title: 'John Carulli',
          text: 'GlobalFoundries',
        },
        {
          title: 'Krishnendu Chakrabarty',
          text: 'Duke University',
        },
        {
          title: 'Abhijit Chaterjee',
          text: 'Georgia Tech',
        },
        {
          title: 'Wim Dobbelaere',
          text: 'ON Semiconductor',
        },
        {
          title: 'Said Hamdioui',
          text: 'Delft University of Technology, NL',
        },
        {
          title: 'Pete Harrod',
          text: 'Arm',
        },
        {
          title: 'Martin Keim',
          text: 'Siemens',
        },
        {
          title: 'Bram Kruseman',
          text: 'NXP Semiconductors',
        },
        {
          title: 'Erik Larsson',
          text: 'Lund University, SE',
        },
        {
          title: 'Regis Leveugle',
          text: 'Grenoble INP, FR',
        },
        {
          title: 'Riccardo Mariani',
          text: 'NVIDIA',
        },
        {
          title: 'Peter Maxwell',
          text: 'Retired',
        },
        {
          title: 'Salvador Mir',
          text: 'CNRS/TIMA, FR',
        },
        {
          title: 'Zainalabedin Navabi',
          text: 'University of Tehran, IR',
        },
        {
          title: 'Alex Orailoglu',
          text: 'University of California at San Diego, US',
        },
        {
          title: 'Zebo Peng',
          text: 'Linkoping University, SE',
        },
        {
          title: 'Janusz Rajski',
          text: 'Siemens EDA',
        },
        {
          title: 'Matteo Sonza Reorda',
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Stephen Sunter',
          text: 'Siemens EDA',
        },
        {
          title: 'Jerzy Tyszer',
          text: 'Poznan University of Technology, PL',
        },
        {
          title: 'Hans Martin von Staudt',
          text: 'Dialog Semiconductor, UK',
        },
        {
          title: 'Hans-Joachim Wunderlich',
          text: 'Universitat Stuttgart, DE',
        },
        {
          title: 'Yervant Zorian',
          text: 'Synopsys, US',
        },
        {
          title: 'Teresa McLaurin',
          text: 'ARM, US',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
